module.exports = __webpack_public_path__ + "img/estadio.109ca5cc.jpg";